module.exports = __webpack_public_path__ + "img/05.67a174e5.jpg";